import {
  GET_DATA,
  SEARCH_DATA,
  ADD_ITEM,
  EDIT_ITEM,
  OPEN_EDIT,
  OPEN_PREVIEW,
  RESET_DATA,
  LOG_ACTION,
  LOAD_MORE_DATA,
} from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";

export const getData = (props) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(props.apiurl);
    // console.log(props)
    dataRef = dataRef.orderBy("created_at", "desc");

    // if(props.searchText){
    //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
    // }
    // if(props.filters){
    //   if(props.filters.length > 0){
    //     props.filters.map(item=>{
    //       console.log(item)
    //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
    //     })
    //   }
    // }

    dataRef = dataRef.limit(2500);

    dataRef
      .get()
      .then((documentSnapshots) => {
        var docs = documentSnapshots.docs;
        var lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        var dataArray = [];
        docs.map((item) => {
          var newOrder = {
            key: item.id,
            id: item.id,
            ...item.data(),
          };
          if (props.api == "products") {
            if (
              userRole == "admin" ||
              userRole == "warehouse" ||
              userRole == "manager"
            ) {
              dataArray.push(newOrder);
            } else if (newOrder.hq_only) {
              if (newOrder.hq_only == "false") {
                dataArray.push(newOrder);
              }
            } else {
              dataArray.push(newOrder);
            }
          } else {
            dataArray.push(newOrder);
          }
        });

        dispatch({
          type: GET_DATA,
          payload: {
            dataArray: dataArray,
            lastVisible: lastVisible,
            currentProps: props,
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const loadMoreData = () => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var currentLastItem = reduxState.crudReducer.lastVisible;
    var currentProps = reduxState.crudReducer.currentProps;
    var Firestore = firebase.firestore();

    var dataRef = Firestore.collection(currentProps.apiurl);

    dataRef = dataRef.orderBy("created_at", "desc");
    if (currentLastItem) {
      dataRef = dataRef.startAfter(currentLastItem);

      if (currentProps.searchText) {
        dataRef = dataRef
          .where("name", ">=", currentProps.searchText)
          .where("name", "<=", currentProps.searchText + "\uf8ff");
      }

      dataRef = dataRef.limit(200);

      dataRef
        .get()
        .then((documentSnapshots) => {
          var docs = documentSnapshots.docs;
          var lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];
          var dataArray = [];
          docs.map((item) => {
            var newOrder = {
              key: item.id,
              id: item.id,
              ...item.data(),
            };
            if (currentProps.api == "products") {
              if (
                userRole == "admin" ||
                userRole == "warehouse" ||
                userRole == "manager"
              ) {
                dataArray.push(newOrder);
              } else if (newOrder.hq_only) {
                if (newOrder.hq_only == "false") {
                  dataArray.push(newOrder);
                }
              } else {
                dataArray.push(newOrder);
              }
            } else {
              dataArray.push(newOrder);
            }
          });
          console.log(dataArray);
          if (lastVisible && currentLastItem !== lastVisible) {
            dispatch({
              type: LOAD_MORE_DATA,
              payload: { dataArray: dataArray, lastVisible: lastVisible },
            });
          } else {
            message.error("No More Orders To Load");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      message.error("Nothing to load more of");
    }
  };
};

export const searchData = (filter, data) => {
  return (dispatch) => {
    dispatch({
      type: SEARCH_DATA,
      filter: filter,
      data: data,
    });
  };
};

export const addItem = (data, apiurl) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(apiurl);

    return dataRef.doc().set(data);
  };
};

export const editItem = (data, apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection(apiurl);

    const editableData = { ...data };
    if (apiurl === "products") delete editableData.barcode_number;
    return OrdersRef.doc(id).set(editableData, { merge: true });
  };
};

export const setItem = (data, apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(apiurl);
    return dataRef.doc(id).set(data, { merge: true });
  };
};

export const updateItem = (data, apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(apiurl);
    return dataRef.doc(id).update(data, { merge: true });
  };
};

export const deleteItem = (apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection(apiurl);

    return OrdersRef.doc(id).delete();
  };
};

export const openPreview = (item, previewModalOpen) => {
  return (dispatch) => {
    dispatch({
      type: OPEN_PREVIEW,
      item: item,
      previewModalOpen: previewModalOpen,
    });
  };
};

export const getOptions = (props) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(props.apiurl);
    // console.log(props)
    // console.log('/////////////////////////////////////////')

    if (props.apiurl == "products") {
      if (props?.searchText) {
        // console.log( props.searchText)
        dataRef = dataRef.where("name", ">=", props.searchText);
      }
    } else {
      dataRef = dataRef.orderBy("created_at", "desc");
    }

    // if(props.searchText){
    //   dataRef = dataRef.where('name', '>=', props.searchText).where('name', '<=', props.searchText+ '\uf8ff')
    // }

    dataRef = dataRef.limit(2500);

    return dataRef.get();
  };
};

export const UploadPicture = (token, file) => {
  return (dispatch) => {
    // console.log(process.env.api + apiurl)
    var apiurl = "";
    axios.defaults.headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      axios.defaults.headers = {
        Authorization: `Bearer ${token}`,
      };
    }
    var data = new FormData();
    data.append("file", file.attachments[0]);

    return axios.post(process.env.api + apiurl, data);
  };
};
